import React from 'react';
import SharedSpinnerLoad from 'shared_items/SpinnerLoad';

// Shim de compatibilidade — implementação real em shared_items/SpinnerLoad.jsx (design-system fase 3b).
// Mantém a mesma interface (incluindo `size`) e o MESMO CAMINHO DE ARQUIVO de propósito: este
// arquivo tem 8 call sites (incluindo shared_items/embeddedNotepad/*), renomeá-lo exigiria
// atualizar todos eles — deixei pra fase 4 (ver docs/design-system/README.md).
const SpinnerLoad = (props) => <SharedSpinnerLoad moduleKey="notepad" {...props} />;

export default SpinnerLoad;
